module.exports = __webpack_public_path__ + "img/yakor.784531aa.svg";